import Layout from './layout'
import SafeManage from './manage/safe-manage-routing'
import Password from './password/safe-password-routing'
import Phone from './phone/safe-phone-routing'
import Email from './email/safe-email-routing'
export default [
  {
    path: '/safe',
    name: 'safe',
    component: Layout,
    redirect: { name: 'safe-manage' },
    children: [
      ...SafeManage,
      ...Password,
      ...Phone,
      ...Email
    ]
  },
]
